import { render, staticRenderFns } from "./RankingAppoiments.vue?vue&type=template&id=60e1e3cf"
import script from "./RankingAppoiments.vue?vue&type=script&lang=js"
export * from "./RankingAppoiments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports